// extracted by mini-css-extract-plugin
export var pageContainer = "_j-1";
export var settingsContent = "_j-0";